var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapa"},[_c('div',{ref:"ctn",staticClass:"d-flex align-self-stretch",style:(("height: " + _vm.alt + "px; z-index:3")),attrs:{"id":"mapContainer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }